import React, { useState, useRef } from "react";
import Button from "../Button";
import Modal from "../../Modal";
import Form from "../Form";
import Input from ".";
import { FiX } from "react-icons/fi";

function EditableInput({ value, type, label = "", noNumbers, allowSpecialChars, required = false, onChange = () => {}, onUpdate = () => {}, className = "", loading }) {
	const [Edit, setEdit] = useState();
	const [Value, setValue] = useState(value);

	const INPUT = useRef();

	const onSubmit = () => {
		const val = INPUT.current.value;
		onUpdate(val);
		setEdit();
	};

	return (
		<>
			<Button onClick={() => setEdit(true)} variant="outlined" className={`!inline-block align-middle btn-xs mr-2 ${className}`}>
				Edit
			</Button>
			<Modal open={Edit} onClose={() => setEdit()} contentClass="w-full max-w-md !p-0 overflow-hidden" showCloseButton={false}>
				<Form onSubmit={onSubmit}>
					<div className="flex items-center justify-between p-4 border-b border-surface">
						<h3>Edit {label || "Value"}</h3>
						<button type="button" onClick={() => setEdit()} className="p-1 text-secondary hover:text-dark" aria-label="Close edit dialog">
							<FiX className="w-5 h-5" />
						</button>
					</div>
					<div className="p-4">
						<Input noNumbers={noNumbers} allowSpecialChars={allowSpecialChars} required={required} ref={INPUT} placeholder={label} type={type} value={Value} onChange={(val) => setValue(val)} className="w-full" />
						<div className="grid grid-cols-1 gap-2 mt-3 sm:grid-cols-2">
							<Button loading={loading} type="submit" className="w-full sm:order-2">
								Update
							</Button>
							<Button type="button" variant="outlined" className="w-full sm:order-1" onClick={() => setEdit()}>
								Cancel
							</Button>
						</div>
					</div>
				</Form>
			</Modal>
		</>
	);
}

export default EditableInput;
